import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, reset } from 'redux-form';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import Button from 'react-bootstrap/lib/Button';
import Col from 'react-bootstrap/lib/Col';
import Panel from 'react-bootstrap/lib/Panel';

import InputFieldComponent from '../../Common/FormField/InputFieldComponent';

import validate from './validate';
import messages from '../../../locale/messages';
import showToaster from '../../../helpers/showToaster';
import { withMutation } from '../../../hoc/withGraphql';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

import s from './ChangeAdminForm.css';
import bt from '../../../components/commonStyle.css';
class ChangeAdminForm extends Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
  }

  async submitForm(values, dispatch) {
    const { mutate, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
		if (isRestrict) return;

    const { data } = await mutate({ variables: values });
    if (data && data.changeAdminUser) {
      showToaster({
        messageId: data?.changeAdminUser?.status === '200' ? 'changeAdminUser' : 'changeUserError',
        toasterType: data?.changeAdminUser?.status === '200' ? 'success' : 'error'
      })
    }
    dispatch(reset('ChangeAdminForm'));
  }

  render() {
    const { error, handleSubmit, submitting, dispatch, title, isSuperAdmin } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div>
        <h1 className={s.siteAdminHeading}><FormattedMessage {...messages.changeAdminPassword} /></h1>
        <Col xs={12} sm={12} md={9} lg={8} className={s.blockCenter}>
          <Panel className={cx(s.panelHeader)}>
            <form onSubmit={handleSubmit(this.submitForm)}>
              {error && <strong>{formatMessage(error)}</strong>}
              {
                isSuperAdmin && <Field
                  name="email"
                  type="text"
                  component={InputFieldComponent}
                  label={formatMessage(messages.email)}
                  note={formatMessage(messages.changeAdminPasswordDesc)}
                  inputClass={bt.commonControlInput}
                  formGroupClass={bt.space4}
                  placeholder={formatMessage(messages.emailPlaceHolder)}
                />
              }
              <Field name="password"
                type="password"
                component={InputFieldComponent}
                label={formatMessage(messages.password)}
                inputClass={bt.commonControlInput}
                formGroupClass={bt.space4}
                placeholder={formatMessage(messages.passwordPlaceHolder)} />

              <Field name="confirmPassword"
                type="password"
                component={InputFieldComponent}
                label={formatMessage(messages.confirmPassword)}
                inputClass={bt.commonControlInput}
                formGroupClass={bt.space4}
                placeholder={formatMessage(messages.confirmPasswordPlaceHolder)} />

              <div className='singleButtonFlexEnd'>
                <Button className={cx(bt.btnPrimary, bt.btnLarge)} type="submit" disabled={submitting} >
                  <FormattedMessage {...messages.save} />
                </Button>
              </div>
            </form>
          </Panel>
        </Col>
      </div>
    );
  }

}

ChangeAdminForm = reduxForm({
  form: 'ChangeAdminForm', // a unique name for this form
  validate
})(ChangeAdminForm);

const mapState = (state) => ({
  isSuperAdmin: state.runtime.isSuperAdmin,
});

const mapDispatch = {
  demoRestriction
};

export default compose(injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
  withMutation(gql`
    mutation changeAdminUser($email: String, $password: String!) {
      changeAdminUser (email: $email, password: $password) {
        status
      }
    }
  `),
)(ChangeAdminForm);